export enum SessionStoreItem {
  IdToken = 'tms-id-token',
  ShipmentNumber = 'tms-shipment-number'
};
